import { Select } from 'antd';
import React, { useState, useEffect } from 'react'
import axios from 'axios'

const { Option } = Select;

export default function SelectNegozi(props) {

    const [shops, setShops] = useState([])

    function fetchNegozi() {
        axios
            .get(
                `${process.env.REACT_APP_SERVER_URL}/api/negozi/all`
            )
            .then((response) => {
                // this.setState({ dataSource: response.data.dateFilter.buckets[0].negozi.buckets }, () => { console.log(this.state.dataSource) })
                console.log(response)
                setShops(response.data)
            })
            .catch((error) => {
                // handle error
                console.log(error);
            })
            .then(() => {
                // always executed
            });
    }

    useEffect(() => {
        fetchNegozi()
    }, []);

    function onChange(value) {
        console.log(`selected ${value}`);
        props.selectNegozio(value)
    }

    function onBlur() {
        console.log('blur');
    }

    function onFocus() {
        console.log('focus');
    }

    function onSearch(val) {
        console.log('search:', val);
    }

    function renderOptions() {

        console.log(props.role)

        if (props.role === "all") {
            return shops.map((shop) =>
                <Option key={shop.id} value={shop.username}>{shop.username}</Option>
            );
        } else {
            return <Option key={props.negozio} value={props.negozio}>{props.negozio}</Option>
        }

    }

    return (
        <div>
            <Select
                showSearch
                style={{ width: 400 }}
                placeholder="Selezionare un negozio"
                optionFilterProp="children"
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                defaultValue={props.role === "admin" ? "all" : props.negozio}
                onSearch={onSearch}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {props.role === "all" && <Option value="all">Tutti</Option>}
                {props.role === "all" && <Option value="">Transazioni non associati ad un negozio</Option>}

                {renderOptions()}
            </Select>

        </div>
    )

}


